import React, { Fragment, useState,useContext } from 'react'
import {IAppTableColumnProps} from './AppTableColumn'
import {Checkbox,Icon} from 'antd'
import {AppTableContext} from "./AppTable"
import {appFormat} from "utils"
import {AppTableEditItem} from "./AppTableEditItem";

interface RowProps {
	rowKey?: string;
    columns?: IAppTableColumnProps[];
    data?: any;
	dataIndex?: number;
}

interface ColProps extends IAppTableColumnProps {
	data?: any;
	dataIndex?: number;
}

export const AppTableRow = (props:RowProps) =>{
    let { columns,data,dataIndex } = props; 
    let {hoverRow,currRow,rowHover,rowClick} = useContext(AppTableContext);
    let rowKey = props.rowKey||'id';
    let isHover = data[rowKey] === hoverRow[rowKey];
    let trClassName = data[rowKey] ===currRow[rowKey] ? 'app-table-row-selected':'app-table-row';

    const handleRowHover = () =>{
		if(data[rowKey]===hoverRow[rowKey]) return;
		rowHover(data);
    }
    
    const handleRowClick = () =>{
		if(data[rowKey]===currRow[rowKey]) return;
		rowClick(data);
	}

    return (
        <tr key={`${data[rowKey]}_TR`}
            className={trClassName}
            data-hover = {isHover}
            hidden = {data.__tree_hidden}
            onMouseOver={() => { handleRowHover() }}
            onClick={() => { handleRowClick() }}
            >
            {columns.map((column: IAppTableColumnProps,index) => {
                let tdKey = `${data[rowKey]}_${index}`
                return <AppTableCol key ={tdKey} {...column} data={data} dataIndex={dataIndex} />;
            })}
        </tr>)
}




export const AppTableCol = (props:ColProps) =>{
    const { rowSelected ,handleExpand} = useContext(AppTableContext)
    const {data,dataIndex,field,format} = props

    const isEdit = () =>{
        if(props.editType){
            if(props.editAllow && !props.editAllow(data,dataIndex)) return false;
            return true;
        }
        return false;
    }

    const checkbox = () =>{
        return <div> <Checkbox 
        checked={data.__table_checked} 
        indeterminate = {data.indeterminate}
        onChange={(e)=>{rowSelected(data,e.target.checked)}} 
        /></div>
    }

    const getContent = () =>{
        if(props.field === "__table_check_box") {
            return checkbox()
        } else if(props.render) {
            return props.render(data,dataIndex);
        }else if(isEdit()) {
            return <AppTableEditItem {...props} value={data[field] || ''} dataIndex={dataIndex}/>
        }else{
            return appFormat(data[field], format);
        }
    }
    

    const renderExpand = () =>{
        return (
        <td className="tree-td">
            <div className="tree-td-blank" style={{width:data.__tree_blank_width}}></div>
            <div className="tree-data">
                {data.isEnd ===1 ? <React.Fragment/> : 
                                    <span className='tree-icon' 
                                           onClick={()=>{handleExpand(data)}}>
                                        <Icon type={data.__tree_expand_icon} />
                                    </span>}
                {getContent()}
            </div>
        </td>
        )
    }

    const renderItem = () =>{
       if(props.expand) return renderExpand();

       let className = `app-table-row-td-${props.align || 'left'}`;
       return (<td className={className}>
                <div className="app-table-row-td-inner app-table-row-td-nowrap">
                    {getContent()}
                </div>
                </td>)
     
    }

    return renderItem();
}







// WEBPACK FOOTER //
// ./src/components/AppTable/AppTableItem.tsx